import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_PREFIX = '/api';

const api = axios.create({
  baseURL: `${API_BASE_URL}${API_PREFIX}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const askQuestion = async (question, options = {}) => {
  try {
    const ex = options.excludeProductUrls;
    const excludeProductUrls =
      Array.isArray(ex) ? ex : ex ? [] : null;

    const response = await api.post('/ask/', {
      question,
      use_web: options.useWeb || false,
      user_email: options.userEmail || '',
      conversation_history: options.conversationHistory || [],
      exclude_product_urls: excludeProductUrls,
    });
    return response.data;
  } catch (error) {
    console.error('Error asking question:', error);
    throw error;
  }
};

export const saveContact = async (name, email) => {
  try {
    const response = await api.post('/contacts/', {
      name,
      email,
    });
    return response.data;
  } catch (error) {
    console.error('Error saving contact:', error);
    throw error;
  }
};

export const getContacts = async () => {
  try {
    const response = await api.get('/contacts/');
    return response.data;
  } catch (error) {
    console.error('Error fetching contacts:', error);
    throw error;
  }
};

export default api;
